<template>
  <div>
    <div class="title">
      {{ _[copy.model] }} ID: {{ copy.id }}
      <span @click="closeModal()"><font-awesome-icon :icon="['fas', 'times']" /></span>
    </div>
    <div class="content">
      <div class="confirm">
        <b>{{ _['sure_to_clone_' + copy.model] }}</b>
        <div class="control">
          <span class="button delete" @click="copyItem()">{{ _.yes_clone }}</span>
          <span class="button cancel" @click="closeModal()">{{ _.no_cancel }}</span>
        </div>
      </div>
      <div class="including" v-if="copy.model === 'session'">
        <p>
          <input type="checkbox" true-value="1" false-value="0" v-model="including_persons" />
          {{ _.including_persons}}
        </p>
        <p>
          <input type="checkbox" true-value="1" false-value="0" v-model="including_presentations" />
          {{ _.including_presentations }}
        </p>
      </div>
      <div v-if="copy.model === 'presentation'">
        <p>
          <input type="checkbox" true-value="1" false-value="0" v-model="including_persons" />
          {{ _.including_persons}}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'
export default {
  data() {
    return {
      including_persons: '0',
      including_presentations: '0',
    }
  },
  computed: {
    ...mapGetters(['copy']),
  },
  methods: {
    ...mapMutations(['closeModal']),
    ...mapActions('session', ['cloneSession']),
    ...mapActions('presentation', ['clonePresentation']),
    copyItem() {
      const params = this.copy.model === 'session'
        ? { including_persons: this.including_persons, including_presentations: this.including_presentations }
        : { including_persons: this.including_persons };
      this['clone' + this.copy.model.charAt(0).toUpperCase() + this.copy.model.slice(1)](params);
    },
    handleKeyUp(event) {
      if (event.keyCode === 13) {
        this.copyItem();
      }
    }
  },
  created() {
    window.addEventListener('keyup', this.handleKeyUp);
  },
  destroyed() {
    window.removeEventListener('keyup', this.handleKeyUp);
  },
}
</script>

<style lang="scss">
@import '@/assets/scss/variables.scss';
.modal {
  > div {
    > div {
      display: grid;
      grid-template-rows: 40px 1fr;
      grid-template-columns: 1fr;
      height: 100%;
      > .title {
        grid-area: 1/1/2/2;
        background: $primary-color;
        color: #ffffff;
        padding: 12px;
        font-weight: bold;
        > span {
          float: right;
          margin-right: 4px;
          opacity: .4;
          &:hover {
            opacity: 1;
          }
        }
        .svg-inline--fa {
          cursor: pointer;
        }
      }
      > .content {
        grid-area: 2/1/3/2;
        background: #ffffff;
        overflow-y: scroll;
        position: relative;
        > div {
          &.confirm {
            background: lighten($error-color, 70%);
            color: $error-color;
            border-bottom: 1px solid lighten($error-color, 60%);
            line-height: 28px;
            padding: 12px;
            > .control {
              float: right;
              .button {
                padding: 8px 12px;
                cursor: pointer;
                font-weight: bold;
                &.delete {
                  border-radius: 4px 0 0 4px;
                  border: 1px solid $error-color;
                  background: $error-color;
                  color: #ffffff;
                }
                &.cancel {
                  border-radius: 0 4px 4px 0;
                  border: 1px solid lighten($error-color, 60%);
                }
              }
            }
          }
          &.including {
            > p {
              padding-bottom: 0;
              > input {
                position: relative;
                vertical-align: middle;
                bottom: 1px;
                margin-right: 4px;
              }
            }
          }
          > div {
            position: relative;
          }
        }
      }

    }
  }
}

</style>